import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-756fbd00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rows-container" }

import { ref, computed } from 'vue';
import type { ComponentExposed } from 'vue-component-type-helpers';
import { DisplayableKeys } from '@/services/SorterService';
import TablePersistentChecking from '../TablePersistentChecking.vue';
export interface TableExpandableRowsProps<T> {
    rows?: T[];
    cols: DisplayableKeys<T>[];
    /** number of rows to show before hiding with expand button*/
    maxRows?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TableExpandableRows',
  props: {
    rows: {},
    cols: {},
    maxRows: { default: 3 }
  },
  emits: ["expand", "collapse"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emits = __emit;
__expose<{
    checkAll:()=>void;
}>({
    checkAll: ()=>table.value?.CheckAll(),
});
const table = ref<ComponentExposed<typeof TablePersistentChecking>>();
const expanded = ref(false);
const rowsPerPage = computed(()=>expanded.value?props.rows?.length??props.maxRows:props.maxRows);
const showExpand = computed(()=>(props.rows?.length ?? 0) > props.maxRows);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TablePersistentChecking, _mergeProps({
      ref_key: "table",
      ref: table
    }, _ctx.$attrs, {
      Rows: _ctx.rows,
      Cols: _ctx.cols,
      RowsPerPage: rowsPerPage.value,
      "onUpdate:RowsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((rowsPerPage).value = $event)),
      DisablePaging: "",
      style: {"flex":"0 1 fit-content"}
    }), null, 16, ["Rows", "Cols", "RowsPerPage"]),
    (showExpand.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "expand",
          onClick: _cache[1] || (_cache[1] = ($event: any) => {expanded.value=!expanded.value;expanded.value?emits('expand'):emits('collapse');})
        }, _toDisplayString(expanded.value ? 'Collapse rows...' : 'Expand rows...'), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})